// src/pages/RootLayout.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function RootLayout() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />

      <div style={{ flexGrow: 1, backgroundColor: 'var(--bg-light)' }}>
        <Outlet />
      </div>

      <Footer />
    </div>
  );
}
